import React, { Component } from 'react'

export default class WorkLoad extends Component {
    state = {
        tooltip: false,
        workload: [
            { height: '250px', src: '/images/video/vid1.jpg', name: 'Sara Mohammadi', progress: '30%', taskname: '' },
            { height: '200px', src: '/images/video/vid2.jpg', name: 'Aqdas Mirza', progress: '70%', taskname: '' },
            { height: '240px', src: '/images/video/vid3.jpg', name: 'Ali Salar', progress: '5%', taskname: '' },
            { height: '180px', src: '/images/video/vid4.jpg', name: 'MohammadReza Anguti', progress: '43%', taskname: '' },
            { height: '230px', src: '/images/video/vid5.jpg', name: 'Ho3ein Morshedi', progress: '98%', taskname: '' },
            { height: '190px', src: '/images/video/vid6.jpg', name: 'Ali Panahi', progress: '43%', taskname: '' },
            { height: '250px', src: '/images/video/vid7.jpg', name: 'Mina Mahmoodi', progress: '62%', taskname: '' },

        ]

    }
    render() {
        return (
            <div className='dashboard-widgets w-100 d-flex scroll-no-scrollbar pt-5 px-3' style={{ alignItems: 'baseline' }}>
                {this.state.workload.map((prop, index) => {
                    return (
                        <div key={index} onMouseOver={() => this.setState({ tooltip: !this.state.tooltip })} style={{ width: '100px   ' }} className='mrd-4 flexc flex-column'>
                            <div className='cursor-pointer br-5 mb-2 tooltip' style={{ position: 'relative', height: prop.height, borderLeft: "8px solid #E0E9CA", transform: 'rotate(180deg)' }}>
                                <div className='position-absolute transition-all br-10' style={{ height: prop.progress, borderLeft: '8px solid #62D54C', margin: '0 0 0 -8px' }}></div>
                                <div style={{ transform: 'rotate(180deg)' }} className='tooltip-content'>
                                    <p className='text-smaller '>{prop.name}</p>
                                    <p>Progress : {prop.progress}</p>
                                </div>
                            </div>
                            <div className='br-100' style={{ width: '50px', height: '50px' }}>
                                <img className='w-100 h-100 br-100' src={prop.src} alt="profile" />
                            </div>
                            <div className='w-100 flexcc text-center'>
                                <p className='color-muted text-smaller wrap'>{prop.name}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}
